module.exports = __webpack_public_path__ + "static/media/12UNCTAD14.703b86c4.jpg";